export const categoriesMX = [
    {
        id: 'Corn',
        icon: 'corn',
        category: 'Maíz',
        color: 'orange',
        subcategories: [
            { id: 'Hybrids', subcategory: 'Híbridos', icon: 'corn', color: 'orange' },
            { id: 'Agronomic Practices', subcategory: 'Prácticas agronómicas', icon: 'corn', color: 'orange' },
            { id: 'Weeds', subcategory: 'Malezas', icon: 'weeds', color: 'orange' },
            { id: 'Diseases', subcategory: 'Enfermadades', icon: 'diseases', color: 'orange' },
            { id: 'Pests', subcategory: 'Plagas', icon: 'pests', color: 'orange' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'orange' },
        ],
    },
    {
        id: 'App',
        icon: 'consultApps',
        category: 'App',
        color: 'blue',
        subcategories: [
            { id: 'Problem', subcategory: 'Tengo un problema', icon: 'problem', color: 'blue' },
            { id: 'How to', subcategory: 'Cómo funciona', icon: 'howItWorks', color: 'blue' },
            { id: 'Other', subcategory: 'Otros', icon: 'others', color: 'blue' },
        ],
    },
    { id: 'Other', icon: 'others', category: 'Otros', color: 'green-light', subcategories: [] },
];
